resultWithoutPartial